export default __webpack_public_path__ + "static/media/manufacturing.f8ec8549.svg";